// useHolidays.js
import { useEffect, useState } from 'react';

const CAL_MAP = {
  pl: 'pl.polish#holiday@group.v.calendar.google.com',
};

export function useHolidays({ country = 'pl', from, to, apiKey }) {
  const [events, setEvents] = useState([]);
  const calId = CAL_MAP[country] || CAL_MAP.pl;

  useEffect(() => {
    if (!apiKey) return;

    const timeMin = (
      from ?? new Date(Date.now() - 1000 * 60 * 60 * 24 * 360)
    ).toISOString(); // domyślnie 12 miesięcy wstecz
    const timeMax = (
      to ?? new Date(Date.now() + 1000 * 60 * 60 * 24 * 540)
    ).toISOString(); // domyślnie 18 miesięcy do przodu
    const cacheKey = `holidays:${country}:${timeMin}:${timeMax}`;

    // proste cache w localStorage (6h)
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      const { at, data } = JSON.parse(cached);
      if (Date.now() - at < 6 * 60 * 60 * 1000) {
        setEvents(data);
        return;
      }
    }

    const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(
      calId,
    )}/events?key=${apiKey}&singleEvents=true&maxResults=2500&orderBy=startTime&timeMin=${encodeURIComponent(
      timeMin,
    )}&timeMax=${encodeURIComponent(timeMax)}`;

    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error('Google API error');

        return r.json();
      })
      .then((json) => {
        const items = json.items ?? [];
        const filtered = items.filter((ev) =>
          ev.description.includes('Święto państwowe'),
        );
        const mapped = filtered.map((ev) => {
          const isAllDay = !!ev.start?.date;
          const startISO =
            ev.start?.dateTime ||
            (isAllDay ? `${ev.start.date}T00:00:00.000Z` : undefined);
          const endISO =
            ev.end?.dateTime ||
            (ev.end?.date ? `${ev.end.date}T00:00:00.000Z` : undefined);
          return {
            id: ev.id,
            title: ev.summary,
            start: startISO,
            end: endISO,
            allDay: isAllDay,
            // jako tło:
            display: 'background',
            // albo kolorowe wydarzenie (bez tła):
            // color: '#e57373'
          };
        });
        setEvents(mapped);
        localStorage.setItem(
          cacheKey,
          JSON.stringify({ at: Date.now(), data: mapped }),
        );
      })
      .catch(console.error);
  }, [apiKey, country, from, to]);

  return events;
}
